import React from 'react';
import {ProspectPool} from 'api';
import {Popover} from 'components/antd';
import {getTagFontColor} from 'helpers/tagColors';
import {PlusSquare} from 'components/Ui/Icon';
import TagSelect from './TagSelect';
import useClientUser from 'hooks/useClientUser';

interface Props {
  prospectPool: ProspectPool;
}

export default ({prospectPool}: Props) => {
  const {isMember} = useClientUser();
  const [isPopoverVisible, setPopoverVisible] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const prospectTags = prospectPool?.prospectTags || [];

  const DISPLAY_LIMIT = 10;
  const hasMoreTags = prospectTags.length > DISPLAY_LIMIT;
  const displayedTags = isExpanded ? prospectTags : prospectTags.slice(0, DISPLAY_LIMIT);

  return (
    <div className="flex flex-col gap-1 my-1" style={{maxHeight: '200px', overflowY: 'auto'}}>
      <div className="flex flex-wrap items-center gap-1">
        {prospectTags.length > 0 ? (
          displayedTags.map((tag) => (
            <span
              key={tag.id}
              className="flex px-1.5 py-0.5 rounded-sm"
              style={{
                backgroundColor: tag.color || 'black',
              }}
            >
              <span
                className="text-xs font-bold leading-4"
                style={{
                  letterSpacing: '0.15px',
                  color: getTagFontColor(tag.color),
                }}
              >
                {tag.name}
              </span>
            </span>
          ))
        ) : (
          <span>未設定</span>
        )}
        {isMember && (
          <Popover
            content={() => <TagSelect prospectPool={prospectPool} />}
            trigger="click"
            visible={isPopoverVisible}
            onVisibleChange={(visible) => setPopoverVisible(visible)}
            placement="bottomLeft"
          >
            <button
              className="cursor-pointer h-6 bg-transparent p-0"
              onClick={() => setPopoverVisible(true)}
            >
              <PlusSquare className="w-6 h-6" />
            </button>
          </Popover>
        )}
      </div>
      {hasMoreTags && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-xs text-blue-600 hover:text-blue-800 cursor-pointer bg-transparent border-none p-0 text-left"
        >
          {isExpanded
            ? `▲ 折りたたむ`
            : `▼ さらに ${prospectTags.length - DISPLAY_LIMIT} 件表示`}
        </button>
      )}
    </div>
  );
};
